export default __webpack_public_path__ + "static/media/42-min.8936c743.png";